import { api } from 'utils/api';
import { trackEvent } from 'utils/trackEvent';
import { SearchResponse, searchResponseSchema } from 'domain/documents/schemas/document';

// La recherche vit dans le service `discovery` (docs/discovery/RESTAPI-DISCOVERY.md §2.1). Il ne
// connaît aucun modèle métier : il indexe ce que ses sources lui décrivent et rend des liens que la
// source a composés. Ses résultats sont les mêmes éléments que ceux des favoris et des récents,
// d'où le schéma partagé.
const BASE = import.meta.env.VITE_DISCOVERY_SERVICE_URL;

export type Datasource = 'Forms' | 'Site';

export type SearchQuery = {
  query: string;
  currentPage: number;
  pageSize: number;
  datasource?: Datasource;
};

const EMPTY_SEARCH: SearchResponse = { totalResult: 0, results: [] };

// La clé d'un filtre est sensible à la casse et doit nommer un champ de l'index : une valeur
// fourre-tout comme « all » ne serait satisfaite par aucun document et rendrait zéro résultat.
// L'absence de filtre, elle, cherche bien dans toutes les sources.
const buildFilters = (datasource?: Datasource) => (datasource ? [{ key: 'Datasource', value: datasource }] : []);

export const searchService = {
  // La route s'appelle `preview` : un nom hérité de l'ancien SearchService, conservé côté serveur
  // pour ne pas casser ses clients. C'est bien la recherche, et sa seule route ouverte à tous.
  search: async ({ query, currentPage, pageSize, datasource }: SearchQuery): Promise<SearchResponse> => {
    const trimmedQuery = query.trim();
    const filters = buildFilters(datasource);

    // Le service refuse une requête sans texte **et** sans filtre par un 400 : autant ne pas la poser.
    if (!trimmedQuery && filters.length === 0) return EMPTY_SEARCH;

    if (trimmedQuery) trackEvent({ category: 'Search', action: 'Search', label: trimmedQuery });

    const response = await api.post<unknown>(BASE, 'preview', {
      query: trimmedQuery,
      filters,
      currentPage,
      pageSize,
    });

    return searchResponseSchema.parse(response);
  },
};
